<template>
  <div>
    <v-card class="main-card">
      <div class="d-flex justify-space-between">
        <div>
          <p class="fs-xlarge">
            لیست کیک‌های سهام
            <span v-if="pies.length" class="fs-medium grey--text"
              >({{ pies.length }} کیک)</span
            >
          </p>
        </div>

        <div>
          <v-btn color="error" @click="$router.go(-1)">بازگشت</v-btn>
        </div>
      </div>

      <div class="mt-10">
        <!-- TABLE -->
        <template>
          <div class="custom-table">
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="computedPies"
              :page.sync="CurrentPage"
              :items-per-page="PerPage"
              :hide-default-footer="true"
              :loading="tableLoading"
              loading-text="در حال بارگذاری اطلاعات..."
            >
              <template v-slot:top>
                <v-row class="mb-4 mt-1">
                  <v-col cols="12">
                    <v-text-field
                      v-model="searchField"
                      placeholder="جستجوی کیک سهام..."
                      filled
                      rounded
                      hide-details
                      id="search-field"
                    >
                      <template v-slot:prepend-inner>
                        <div class="me-5">
                          <v-icon
                            v-if="searchField"
                            color="grey"
                            style="margin-top: 1px"
                            @click="searchField = ''"
                            >mdi-close</v-icon
                          >
                        </div>
                        <div>
                          <v-icon>mdi-magnify</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </template>
              <!-- End Search-->
              <template slot="no-data">
                <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
              </template>

              <template v-slot:[`item.name`]="{ item }">
                <span>{{ item.name ? item.name : "-" }}</span>
              </template>

              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="primary" @click="$router.push('/home/' + item.id)"
                  ><v-icon>mdi-eye-outline</v-icon></v-btn
                >
              </template> -->
            </v-data-table>
            <v-pagination
              v-model="CurrentPage"
              :length="Math.ceil(computedPies.length / PerPage)"
              :total-visible="5"
              prev-icon="mdi-arrow-left"
              next-icon="mdi-arrow-right"
              class="mt-8"
            ></v-pagination>
          </div>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      PerPage: 10,
      CurrentPage: 1,
      headers: [
        { text: "نام کیک سهام", sortable: false, value: "name" },
        // { text: "عملیات", sortable: false, value: "actions" },
        { text: "نام اعضا", sortable: false, value: "users" },
      ],
      pies: [],
      searchField: "",
      tableLoading: false,
    };
  },

  mounted() {
    this.getPies();
  },

  methods: {
    getPies() {
      this.tableLoading = true;
      this.$http
        .get(this.baseUrl + "/admin/pies/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.pies = res.data;
              this.tableLoading = false;
            }, 500);
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
  },
  computed: {
    computedPies() {
      let filtered = this.pies.filter((x) => x.name.includes(this.searchField));
      return filtered;
    },
  },
};
</script>

<style lang="scss" scoped></style>
